import React from 'react';
import { Component } from '../../../dispatcher/modules';
import { 
  CONDITIONAL_FIELD_PROPS,
  CONDITIONAL_FILTER_FIELD_STATE 
} from './Types';
import PuzzleComboBox from '../../UI/fields/combo/PuzzleComboBox';
import _ from 'lodash';
import PuzzleDropDownList from '../../UI/fields/dropdown_list/PuzzleDropDownList';
import HBox from '../../layout/container/h_box/HBox';

/**
 * Conditional field component
 * Adds one simple condition
 */
class ConditionalField extends Component<CONDITIONAL_FIELD_PROPS, CONDITIONAL_FILTER_FIELD_STATE> {
  /**
   * The list of condition operators
   * @private conditionOperators
   */
  private conditionOperators = [
    'isEqualTo',
    'isNotEqualTo',
    'isEmpty',
    'isNotEmpty',
    'contains',
    'doesNotContain'
  ]

  constructor(props: CONDITIONAL_FIELD_PROPS) {
    super(props);

    let value;
    let type;
    const names = this.getNames();
    let name = names.length ? names[0] : undefined; // sets the first item

    const operators = this.getOperators();
    let operator = operators.length ? operators[0] : undefined; // sets the first operation

    let fieldData = this.props.fieldData;
    if (fieldData && !_.isEmpty(fieldData.name)) { // if there is fieldData prop then set values from the props
      name = this.findByName(fieldData.name, names);
      operator = this.findByName(fieldData.operator, operators);
      value = fieldData.value;
      type = fieldData.type;
    }

    this.state = {
      ...this.state,
      ...props,
      name,
      operator,
      type,
      value
    };
  }

  /**
   * Returns the list of all condition operators translated
   * @returns conditionOperators
   */
  getOperators = () => {
    let conditionOperators = [];
    this.conditionOperators.map((operator) => {
      conditionOperators.push({
        text: this.translate(`conditionOperators.${operator}`),
        name: operator
      });
    });

    return conditionOperators;
  }

  /**
   * Returns array item found by name value
   * @param {string} value
   * @param {any[]} array
   */
  findByName = (value, array) => {
    let index = array.length;
    let found;
    while (index) {
      index--;

      if (array[index] && array[index].name === value) {
        found = array[index];
      }
    }

    return found;
  }

  /**
   * Returns the list of all condition item names
   * @returns names
   */
  getNames = () => {
    let names = [];
    this.props.data?.map((nameProps) => {
      names.push({
        text: this.translate(`${nameProps.name}`),
        name: nameProps.name,
        values: nameProps.values
      });
    });

    return names;
  }

  /**
   * Sets the state value for the field
   * @param value
   */
  setValue = (value) => {
    let state = {
      ...this.state,
      ...value
    };

    this.props.onChange && this.props.onChange({
      name: state.name?.name,
      operator: state.operator?.name,
      value: state.value,
      filterId: this.props.filterId,
      e: state.e
    });
    this.setState(state);
  }

  /**
   * Set the filter state after changing the condition name
   * @param {Event} event
   */
  onNameChange = (event) => {
    let name = event.value;
    let values = name.values ? name.values : [];
    this.setValue({
      values,
      name,
      value: null,
      e: event
    });
  };

  /**
   * Set the filter state after changing the condition operator
   * @param {Event} event
   */
  onOperatorChange = (event) => {
    let operator = event.value;
    this.setValue({
      operator
    });
  };

  /**
   * Set the filter state after changing the condition value
   * @param {Event} event
   */
  onValueChange = (event) => {
    let value = event.value;
    this.setValue({
      value
    });
  };

  /**
   * Returns first condition values list
   * @returns {any[]} values
   */
  getDefaultValues = () => {
    let values = this.state.values;
    if (values === undefined) {
      const names = this.getNames();
      const firstName = names.length ? names[0] : undefined;
      if (firstName && firstName.values) {
        values = firstName.values;
      }
    }
    return values;
  };

  renderBody() {
    const names = this.getNames();
    const operators = this.getOperators();

    return (
      <HBox flex1 gap={1}>
        <PuzzleDropDownList
          asField={true}
          clearButton={false}
          data={names}
          textField={'text'}
          dataItemKey={'name'}
          value={this.state.name}
          onChange={this.onNameChange}
        />
        <PuzzleDropDownList
          asField={true}
          clearButton={false}
          data={operators}
          textField={'text'}
          dataItemKey={'name'}
          value={this.state.operator}
          onChange={this.onOperatorChange}
        />
        <PuzzleComboBox
          asField={true}
          clearButton={false}
          data={this.getDefaultValues()}
          allowCustom={true}
          value={this.state.value}
          onChange={this.onValueChange}
          placeholder={this.translate('valuePlaceholder')}
        />
      </HBox>
    );
  }
}

export default ConditionalField;
